import { Injectable } from '@angular/core';
import { AddLicensePayload, AddLicenseResponse } from '@core/utils/models/license.model';
import { HttpHandler } from '@shared/utils/classes/http-handler';
import { HttpResponse } from '@shared/utils/models/http.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class LicenseService extends HttpHandler {
  addLicense(payload: AddLicensePayload): Observable<HttpResponse<AddLicenseResponse>> {
    const url: string = environment.apiUrls.licenses.add;
    return this.post<HttpResponse<AddLicenseResponse>>(url, payload);
  }

  deleteLicense(licenseIds: number[]): Observable<HttpResponse<number>> {
    const url: string = environment.apiUrls.licenses.delete;
    return this.post<HttpResponse<number>>(url, { ids: licenseIds });
  }
}
